export class DocumentoPastaEntidade {
	public OID_DOCUMENTO_PASTA: number;
	public NOM_PASTA: string;
	public OID_DOCUMENTO_PASTA_PAI?: number;
}
